import { render, staticRenderFns } from "./AddEditPrizeDialog.vue?vue&type=template&id=2bcaf416"
import script from "./AddEditPrizeDialog.vue?vue&type=script&lang=js"
export * from "./AddEditPrizeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports